import { useEffect, useState } from "react";
import { styled } from "@mui/material/styles";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import { useSelector, useDispatch } from "react-redux";
import IncomingChatsRedux from "../pages/Support/AdminChatSupport/ChatSection-1-LeftComponent/IncomingChatsRedux";
import AttendedChatsRedux from "../pages/Support/AdminChatSupport/ChatSection-1-LeftComponent/AttendedChatsRedux";
import CustomerChatComponent from "./CustomerChatComponent/CustomerChatComponent";
import { privateApi } from "../api";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import { Menu, MenuItem } from "@mui/material";

import useMediaQuery from "@mui/material/useMediaQuery";
import { IconButton, Drawer } from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import { useTheme } from "@mui/material/styles";
import AppSidebar from "./Sidebar";
import { HeaderCreateBtn } from "./commons/Buttons";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import LabelOutlinedIcon from "@mui/icons-material/LabelOutlined";
import NewTicketView from "../pages/TicketManagement/NewTicketView";
import ExistingTicketView from "../pages/TicketManagement/SavedTicketView";
// import {messaging} from '../utilities/auth-config/firebase-config'
// import { getToken } from "firebase/messaging";
import BusinessIcon from "@mui/icons-material/Business";
import InventoryIcon from "@mui/icons-material/Inventory";
import AddBusinessIcon from "@mui/icons-material/AddBusiness";
import FranchiseSelect from "./FranchiseSelect";
import { openModal } from "../app/Franchise/FranchiseSlice";

const Header = styled(AppBar)({
  gridArea: "header",
  zIndex: 1201,
  background: "#fff", // White background
  color: "#1E293B", // Dark text
  borderBottom: "1px solid #E2E8F0", // Light border
  boxShadow: "none", // Remove shadow
});

const HeaderTitle = styled(Typography)({
  flexGrow: 1,
  color: "#1E293B",
  fontWeight: 600,
});

const AppHeader = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [createAnchorE1, setCreateAnchorE1] = useState(null);
  const [createDrawerOpen, setCreateDrawerOpen] = useState(false);
  const user = useSelector((state) => state.userData?.data);
  const newTicketModalOpen = useSelector(
    (state) => state.ticketManagement.newTicketModalOpen
  );
  const existingTicketModalOpen = useSelector(
    (state) => state.ticketManagement.existingTicketModalOpen
  );
  const isAdminAttendingChats = useSelector(
    (state) => state.chats.isChatModeOn
  );

  const franchise = useSelector(
    (state) => state.franchiseMangement.currentFranchise
  );

  const getUserData = async () => {
    const userId = localStorage.getItem("_id");
    if (!userId) {
      navigate("/login");
      return; // Exit the function if there's no userId
    }

    const path = `users/getUserData/${userId}`;
    try {
      const response = await privateApi.get(path);
      if (response?.data?.message === "Ok")
        dispatch({
          type: "user/updateUserFromAuth",
          payload: response?.data?.data,
        });
    } catch (error) {
      toast.warning("An un-expected error occurred in authorization.");
      navigate("/login");
      localStorage.removeItem("_id");
    }
  };

  useEffect(() => {
    if (!user._id) getUserData();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(() => {
    console.log(isMobile);
  }, [isMobile]);

  const toggleDrawer = () => {
    setDrawerOpen(!drawerOpen);
  };

  const handleCreateDrawerOpen = (event) => {
    setCreateAnchorE1(event.currentTarget);
    setCreateDrawerOpen(true);
  };

  const handleCreateDrawerClose = () => {
    setCreateAnchorE1(null);
    setCreateDrawerOpen(false);
  };

  const getCurrentPage = () => {
    switch (window.location.pathname) {
      case "/":
        return "Dashboard";
      case "/tickets":
        return "Tickets Management";
      case "/Support":
        return "Chat Support";
      case "/User-Management":
        return "User Management";
      case "/Settings":
        return "Settings";
      case "/Settings/CustomFields":
        return "CustomFields";
      case "/Asset-Management":
        return "Asset Management";
      case "/Company-Management":
        return "Company Management";
      case "/export-assets-management":
        return "Wholesale Assets";
      default:
        return "";
    }
  };

  return (
    <Header id="app-header" sx={{ height: "4.5rem", padding: ".2rem" }}>
      <Toolbar>
        {isMobile && (
          <IconButton
            edge="end"
            color="inherit"
            aria-label="menu"
            onClick={toggleDrawer}
            sx={{ marginRight: "20px" }}
          >
            <MenuIcon fontSize="large" />
          </IconButton>
        )}
        <div style={{ width: "200px" }}>
          {" "}
          {/* Set a specific width for the container */}
          <img
            src={
              franchise && franchise?.logoUrl
                ? franchise.logoUrl
                : require("../MediaContents/AFT Logo 2.png")
            }
            alt="Logo"
            style={{ Width: "auto", height: "100%", maxHeight: "4rem" }}
          />
        </div>
        {/* Page Name */}
        <div style={{ width: "110px" }}></div>
        {!isMobile && (
          <HeaderTitle variant="h6" noWrap component="div">
            {getCurrentPage()}
          </HeaderTitle>
        )}
        {
          <div style={{ marginRight: "40px" }}>
            {user.role !== "customerUser" && (
              <HeaderCreateBtn onClick={handleCreateDrawerOpen} />
            )}
          </div>
        }
        {
          <div style={{ marginRight: "40px" }}>
            {user.role === "coreAdmin" && <FranchiseSelect />}
          </div>
        }
        <Menu
          sx={{ marginTop: "5px" }}
          anchorEl={createAnchorE1}
          open={createDrawerOpen}
          onClose={handleCreateDrawerClose}
        >
          {[
            "coreAdmin",
            "superAdmin",
            "technicalAdmin",
            "technician",
            "supportAgent",
          ].includes(user.role) && (
              <MenuItem
                onClick={() => {
                  dispatch({
                    type: "ticketManagement/handleTicketModals",
                    payload: { modalType: "newTicketModalOpen" },
                  });
                  handleCreateDrawerClose();
                }}
              >
                <LabelOutlinedIcon sx={{ marginRight: 1 }} />
                Ticket
              </MenuItem>
            )}
          {[
            "coreAdmin",
            "superAdmin",
            "customerAdmin",
            "technicalAdmin",
            "technician",
            "supportAgent",
          ].includes(user.role) && (
              <MenuItem
                sx={{ minWidth: "125px" }}
                onClick={() => {
                  dispatch({
                    type: "userManagement/updateFieldValues",
                    payload: {
                      state: "createUserData",
                      field: "isCreateModalOpen",
                      value: true,
                    },
                  });
                  handleCreateDrawerClose();
                }}
              >
                <AccountCircleIcon sx={{ marginRight: 1 }} />
                User
              </MenuItem>
            )}
          {[
            "coreAdmin",
            "superAdmin",
            "technicalAdmin",
            "technician",
            "supportAgent",
          ].includes(user.role) && (
              <MenuItem
                onClick={() => {
                  dispatch({
                    type: "companyManagement/updateFieldValues",
                    payload: {
                      state: "mainState",
                      field: "isCreateOrEditModalOpen",
                      value: true,
                    },
                  });
                  handleCreateDrawerClose();
                }}
              >
                <BusinessIcon sx={{ marginRight: 1 }} />
                Company
              </MenuItem>
            )}
          {user.userType === "Admin" && (
            <MenuItem
              onClick={() => {
                dispatch({
                  type: "assetManagement/updateFieldValues",
                  payload: {
                    state: "mainState",
                    field: "isCreateOrEditModalOpen",
                    value: true,
                  },
                });
                handleCreateDrawerClose();
              }}
            >
              <InventoryIcon sx={{ marginRight: 1 }} />
              Asset
            </MenuItem>
          )}
          {"coreAdmin" === user.role && (
            <MenuItem
              onClick={() => {
                dispatch(openModal());
                handleCreateDrawerClose();
              }}
            >
              <AddBusinessIcon sx={{ marginRight: 1 }} />
              Franchise
            </MenuItem>
          )}
          {user.userType === "Admin" && (
            <MenuItem disabled onClick={handleCreateDrawerClose}>
              <DescriptionOutlinedIcon sx={{ marginRight: 1 }} />
              Invoice
            </MenuItem>
          )}
        </Menu>
      </Toolbar>
      {/* <FirebaseActiveUser user={user} /> */}
      {isAdminAttendingChats && (
        <>
          <IncomingChatsRedux />
          <AttendedChatsRedux />
        </>
      )}
      {(user.userType === "Customer" || user.role === "supportAgent") && (
        <CustomerChatComponent />
      )}

      {newTicketModalOpen && <NewTicketView />}
      {existingTicketModalOpen && <ExistingTicketView />}

      {/* Render the sidebar in app drawer from Header */}
      {isMobile && (
        <Drawer
          anchor="left"
          open={drawerOpen}
          onClose={toggleDrawer}
          ModalProps={{ BackdropProps: { invisible: true } }}
        >
          <AppSidebar isMobile={isMobile} setDrawerOpen={setDrawerOpen} />
        </Drawer>
      )}
    </Header>
  );
};

export default AppHeader;
